class AlertError extends Error {
  constructor(alert, ...params) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AlertError);
    }

    this.name = 'AlertError';
    this.alert = alert;
  }
}

export default AlertError;
